export const flatten = (node, descend = true) => {
    const result = [];
    node.descendants((child, pos) => {
        result.push({ node: child, pos });
        if (!descend) {
            return false;
        }
        return undefined;
    });
    return result;
};
export const findChildren = (predicate) => (node, descend) => flatten(node, descend).filter((child) => predicate(child.node));
export const findChildrenByMark = (node, markType, descend) => findChildren((child) => Boolean(markType.isInSet(child.marks)))(node, descend);
//# sourceMappingURL=node.js.map